import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "../../api/user/user.api";

// Initial state for auth
const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

// Async thunk for login
export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await userApi.signin({ username, password });
      localStorage.setItem("token", response.token);

      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Login failed");
    }
  }
);

// Async thunk for signup
export const signup = createAsyncThunk(
  "auth/signup",
  async (
    { username, password, confirmPassword, displayName, photo },
    { rejectWithValue }
  ) => {
    if (password !== confirmPassword) {
      return rejectWithValue("Passwords do not match");
    }

    try {
      const response = await userApi.signup({
        username,
        password,
        confirmPassword,
        displayName,
        photo,
      });

      localStorage.setItem("token", response.token);

      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Signup failed");
    }
  }
);

// Auth slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        console.log(action.payload);

        state.isLoading = false;
        state.isAuthenticated = true;

        state.user = {
          _id: action.payload._id,
          photo: action.payload.photo,
          dateOfBirth: action.payload.dateOfBirth,
          gender: action.payload.gender,
          phone: action.payload.phone,
          bio: action.payload.bio,
          displayName: action.payload.displayName,
          username: action.payload.username,
          token: action.payload.token,
        };

        state.token = action.payload.token;
      })
      .addCase(signup.fulfilled, (state, action) => {
        console.log(action.payload);

        state.isLoading = false;
        state.isAuthenticated = true;

        state.user = {
          _id: action.payload._id,
          photo: action.payload.photo,
          dateOfBirth: action.payload.dateOfBirth,
          gender: action.payload.gender,
          phone: action.payload.phone,
          bio: action.payload.bio,
          displayName: action.payload.displayName,
          username: action.payload.username,
          token: action.payload.token,
        };

        state.token = action.payload.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(signup.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
